/**
 * Sort an object alphabetically by its keys
 * @param unordered Any object with string keys
 * @returns An object with the same properies, but sorted alphabetically by its keys
 */
export default (unordered => Object.keys(unordered).sort().reduce((obj, key) => {
  const typedKey = key;
  obj[typedKey] = unordered[typedKey];
  return obj;
}, {}));
//# sourceMappingURL=sortByKeys.js.map